'use strict'

const hoverBoxSection = require('../sections/hoverBox/hoverBoxSection')
const hoverBoxTheme = require('../sections/hoverBox/hoverBoxTheme')

module.exports = {
    hoverBoxSection,
    hoverBoxTheme
}
